<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-09-30 10:39:37
 * @Version: 1.0
 * @Description: 理化性质组件
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="physicalProperty-container">
    <div class="input-warp" @click="expand">
      <input v-model="showValue" class="el-input__inner" readonly="true" placeholder="请选择理化性质">
      <div class="suffix">
        <i :class="viewControl.expand? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>
    </div>
    <div
      ref="physicalProperty"
      :class="{ 'active': viewControl.expand}"
      class="physicalProperty-panel"
    >
      <ul class="data-items" @keyPress="changeData()">
        <li v-for="(item) of physicalProperty" :key="item.key" class="item">
          <div @change="changeData(item)" @input="changeData()">
            <el-checkbox v-model="selected" :label="item.value">{{ item.label }}</el-checkbox>
            <input v-model="item.data" type="number">
            <span class="suffix">{{ item.unit }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import mixinsFunction from '@/utils/mixinsFunction'
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
import { DocumentListenter } from '@/utils/utilsMethods'

let cancelHook

const split = '@'
export default {
  name: 'PhysicalProperty',
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  mixins: [mixinsFunction],
  props: {
    value: {
      type: String,
      default: () => ''
    }
  },
  data: function() {
    return {
      // 模拟字典数据
      physicalProperty: [],
      // 页面控制
      viewControl: {
        expand: false
      },
      // 已经选择的数据理化性质记录id
      selected: [],
      // 在input文本框显示的数据
      showValue: '',
      // 发射的数据， 要存入数据库的数据
      emitValue: '',
      // 判断是否初始化
      init: false
    }
  },
  computed: {
    // 验证状态
    validateState() {
      return this.elFormItem ? this.elFormItem.validateState : ''
    }
  },
  watch: {
    // 获取value的初始化值
    value: {
      handler: function(value) {
        this.initComponent(value)
      }
    }
  },
  created: function() {
    // 在容器创建期间把外面的传值放到physicalValue里
    if (dataBase.sessionStorageUtil.has('physicalProperty')) {
      this.observer(JSON.parse(dataBase.sessionStorageUtil.get('physicalProperty')))
    } else {
      this.getPhysicalProperty()
        .then(data => {
          dataBase.sessionStorageUtil.set('physicalProperty', JSON.stringify(data))
          this.observer(data)
        })
        .catch(() => {
        // console.error(error)
        })
    }
  },
  mounted: function() {
    cancelHook = new DocumentListenter(this.$el, 'click', this.hidden, this)
  },
  beforeDestroy: function() {
    if (cancelHook) {
      cancelHook.cancel()
    }
  },
  methods: {
    observer(data) {
      this.physicalProperty = data
      this.physicalProperty.forEach(item => {
        const d = item.label.split(split)
        item.label = d[0]
        item.unit = d[1]
        item.data = ''
      })
      this.initComponent(this.value)
    },
    // 初始化组件
    initComponent(value) {
      if (!this.init && value && value !== '') {
        this.stringifyData(value)
        this.init = true
      } else {
        if (this.init && value === '') {
          this.reset()
        }
      }
    },
    // 向父组件分发事件
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },
    // 数据改变触发的事件
    changeData() {
      this.parseData()
      this.emitData()
    },
    // 显示填入理化性质的模板
    expand() {
      this.viewControl.expand = !this.viewControl.expand
    },
    // 发射数据到父组件
    emitData() {
      this.$emit('input', this.emitValue)
      this.$emit('change', this.emitValue)
      if (this.dispatch) {
        this.dispatch('ElFormItem', 'el.form.blur', [this])
      }
    },
    // 解析数据
    parseData() {
      const tempValues = []
      const tempLabels = []
      const tempSelect = []

      this.selected.sort((i, j) => parseInt(i) < parseInt(j))
      // 去重
      this.selected.filter((item, index) => {
        const l = tempSelect.length
        if (l > 0) {
          if (item !== tempSelect[l - 1]) {
            tempSelect.push(item)
          }
        } else {
          tempSelect.push(item)
        }
      })

      tempSelect.forEach(index => {
        const item = this.physicalProperty.filter(i => i.value === index)[0]
        if (item.data && item.data !== '') {
          tempValues.push(`${item.value}@${item.data}`)
          tempLabels.push(`${item.label} : ${item.data} ${item.unit}`)
        }
      })
      this.emitValue = tempValues.toString()
      this.showValue = tempLabels.toString()
    },
    // 数据转为显示数据
    stringifyData(value) {
      if (this.physicalProperty && this.physicalProperty.length > 0) {
        const tempLabels = []
        value
          .split(',')
          .filter(item => item !== '')
          .map(item => {
            const data = item.split('@')
            const i = this.physicalProperty.filter(
              item => item.value === data[0]
            )[0]

            this.selected.push(i.value)
            i.data = data[1]
            tempLabels.push(`${i.label} : ${i.data} ${i.unit} `)
          })
        this.showValue = tempLabels.toString()
      }
    },
    // 隐藏填入的数据
    hidden() {
      this.viewControl.expand = false
    },
    // 重置组件的内部状态
    reset() {
      this.showValue = ''
      this.emitValue = ''
      this.selected = []
      this.physicalProperty.forEach(item => {
        item.data = ''
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.physicalProperty-container {
  width: 100%;
  position: relative;
  .input-warp {
    position: relative;
    height: 38px;
    width: 100%;
    * {
      height: 100%;
      cursor: pointer;
    }
    .suffix {
      display: inline-block;
      width: 25px;
      position: absolute;
      top: 0px;
      right: 0px;
      color: rgb(220, 223, 230);
    }
    input {
      // width: calc(100% - 45px);
      border: 1px solid rgb(220, 223, 230);
      background-color: white;
      outline: 0px;
      margin: 0 0;
      padding: 0px 30px 0px 15px;
      &:hover {
        border-color: rgb(184, 194, 207);
      }
    }
  }

  .physicalProperty-panel {
    display: none;
    position: absolute;
    z-index: 2001;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 5px 0;
    width: 100%;
    padding: 8px 0px;
    // overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
    }

    &.active {
      display: inline-block !important;
    }
    .data-items {
      .item {
        padding: 4px 8px;
        cursor: pointer;
        height: 36px;
        line-height: 30px;
        font-size: 14px;
        white-space: nowrap;
        box-sizing: border-box;
        &:hover {
          background-color: #f5f7fa;
        }
        > div {
          height: 100%;
          display: inline-block;
          width: calc(100% - 35px);
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          > * {
            height: 100%;
          }
          input {
            height: 100%;
            outline: 0px;
            // flex: 0 1 85px;
            width: 120px;
            padding: 0px 8px;
            font-size: 15px;
            border: 1px solid rgb(220, 223, 230);
            margin: 0px 5px;
          }
          .suffix {
            text-align: left;
            display: inline-block;
            height: 100%;
            line-height: 28px;
            width: calc((100% - 150px) / 2);
          }
        }
      }
    }
  }
  .tools-list {
    padding: 8px 8px 0px 8px;
    margin-top: 8px;
    width: calc(100% - 16px);
    text-align: center;
    border-top: 1px solid #ccc;
    display: inline-block;

    /deep/ button {
      border-radius: 0px !important;
    }
  }
}

.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #f56c6c !important;
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #67c23a;
}
</style>

